export const ROUTES_PAGES_MAPPING = [
  ['candidateManager', 'Candidate Manager'],
  ['pendingCandidates', 'Pending Candidates'],
  ['scheduleManager', 'Schedule Manager'],
  ['selectedSchedules', 'Selected Schedules'],
];
